import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import cookieUtils from "../utils/Cookies";
import { getItem, setItem, removeItem } from "../utils/localStorageControl";
import { AUTH_COOKIE_NAME } from "../utils/constants";

// ---------------------------------------------------------------------------
// Encrypted persistence plugin
// ---------------------------------------------------------------------------
// vuex-persistedstate's storage hooks call getItem/setItem/removeItem.
// By wiring them to our encrypted localStorageControl helpers, every field
// that is persisted to localStorage is AES-encrypted at rest automatically.
const encryptedStorage = {
  getItem: (key) => getItem(key),
  setItem: (key, value) => setItem(key, value),
  removeItem: (key) => removeItem(key),
};

export default createStore({
  plugins: [
    createPersistedState({
      storage: encryptedStorage,
    }),
  ],
  state: {
    loggedUser: cookieUtils.get(AUTH_COOKIE_NAME) || {},
    cartItems: [],
    refreshToken: cookieUtils.get(AUTH_COOKIE_NAME)?.refreshToken || "",
    access_token: cookieUtils.get("token") || "",
    isLoggedIn: !!cookieUtils.get("token"),
    roles: [],
    userId: cookieUtils.get(AUTH_COOKIE_NAME)?.id || "",
  },
  getters: {
    loggedUser: (state) => state.loggedUser,
    isLoggedIn: (state) => state.isLoggedIn,
    userApps: (state) => state.loggedUser?.subAppCodes,
    userId: (state) => state.userId,
    token: (state) => state.access_token,
    userType: () => cookieUtils.get("roles")?.[0],
    cartItems: (state) => state.cartItems,
    accessToken: (state) => state.access_token,
    refreshToken: (state) => state.refreshToken,
    cartTotal: (state) => state.cartItems.length,
    totalAmount: (state) => {
      return state.cartItems
        .map((item) => item.packagePrice * item.quantity)
        .reduce((a, b) => {
          return Number(a) + Number(b);
        }, 0);
    },
  },
  mutations: {
    setUser(state, data) {
      state.loggedUser = data;
      state.roles = data.roles;
      state.isLoggedIn = true;
      state.userId = data.id;
      state.refreshToken = data.refreshToken;
      state.access_token = data.jwToken;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken;
    },
    setAccessToken(state, token) {
      state.access_token = token;
    },

    clearUserData(state) {
      state.loggedUser = {};
      state.refreshToken = "";
      state.access_token = "";
      state.isLoggedIn = false;
      state.userId = "";
    },
    clearCart(state) {
      state.cartItems = [];
    },
    addToCart(state, item) {
      state.cartItems = [...state.cartItems, item];
    },
    updateCart(state, item) {
      state.cartItems = [...item];
    },
    setCart(state, item) {
      state.cartItems = item;
    },
    removeFromCart(state, packageId) {
      state.cartItems = state.cartItems.filter(
        (item) => item.packageId !== packageId,
      );
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    async handleAddToCart({ state, commit }, item) {
      let check = state.cartItems.some((i) => i.packageId == item.packageId);
      if (check) {
        return { status: false, message: "Already in cart" };
      }
      commit("addToCart", item);
      return { status: true, message: "Added to cart" };
    },
    async handleCartUpdate({ state, commit }, item) {
      let updatedItem = state.cartItems.map((i) => {
        if (i.packageId == item.packageId) {
          i.quantity = item.quantity;
        }
        return i;
      });

      commit("updateCart", updatedItem);
    },
    async handleToken({ commit }, token) {
      commit("setAccessToken", token);
      return { status: true, message: "updated" };
    },
  },
  modules: {},
});
